var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 14.6667V9.66667H10.667V14.6667H14.8337V8H17.3337L9.00033 0.5L0.666992 8H3.16699V14.6667H7.33366Z",
    fill: "#3E5692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPageIcon);
export default __webpack_public_path__ + "static/media/MainPageIcon.765ae9d2bfb9cf073aef79c355091a23.svg";
export { ForwardRef as ReactComponent };